import React, { useState, useRef } from 'react';
import './Pages/PagesCss/Home.css';
import { NavLink, useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(null);

  const tools = [
    { 
      name: "Payroll Calculator", 
      path: "/PayrollCalculatorUSA", 
      icon: (
    <svg
      width="39"
      height="39"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Calculator body */}
      <rect x="4" y="3" width="16" height="18" rx="2" ry="2" />
      {/* Display */}
      <rect x="6" y="5" width="12" height="4" rx="1" ry="1" />
      {/* Buttons grid */}
      <circle cx="7.5" cy="11.5" r="1" />
      <circle cx="12" cy="11.5" r="1" />
      <circle cx="16.5" cy="11.5" r="1" />
      <circle cx="7.5" cy="15.5" r="1" />
      <circle cx="12" cy="15.5" r="1" />
      <circle cx="16.5" cy="15.5" r="1" />
      <circle cx="7.5" cy="19.5" r="1" />
      <circle cx="12" cy="19.5" r="1" />
      <circle cx="16.5" cy="19.5" r="1" />
    </svg>
  ),
      description: "Calculate comprehensive payroll with taxes, deductions, and net pay in seconds."
    },
    { 
      name: "Tax Estimator",
  path: "/IncomeTaxCalculatorUSA",
  icon: (
    <svg
      width="39"
      height="39"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Bill outline */}
      <rect x="2" y="6" width="20" height="14" rx="3" ry="3" />
      {/* Circular coin/money symbol */}
      <circle cx="12" cy="12" r="3" />
      <line x1="12" y1="9" x2="12" y2="15" />
      <line x1="9" y1="12" x2="15" y2="12" />
      {/* Decorative corner waves */}
      <path d="M2 9 Q4 6 6 9" />
      <path d="M18 9 Q20 6 22 9" />
      <path d="M2 15 Q4 18 6 15" />
      <path d="M18 15 Q20 18 22 15" />
    </svg>
  ),
  description: "Estimate your tax liabilities and optimize your tax strategy effectively."
},
    { 
      name: "Tax Reports",
  path: "/TaxReportsUSA",
  icon: (
    <svg
      width="39"
      height="39"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Document outline */}
      <rect x="3" y="2" width="18" height="20" rx="2" ry="2" />
      {/* Dollar symbol in center */}
      <line x1="12" y1="7" x2="12" y2="17" />
      <path d="M9 10h6" />
      <path d="M9 14h6" />
      {/* Optional top fold for document style */}
      <polyline points="3,6 12,2 21,6" />
    </svg>
  ),
  description: "Generate detailed tax reports to review your liabilities and payments efficiently."
},
    { 
      name: "Property Tax",
  path: "/PropertyTaxCalculatorUSA",
  icon: (
    <svg
      width="39"
      height="39"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* House base */}
      <rect x="6" y="10" width="12" height="10" />
      {/* Roof */}
      <polygon points="3,10 12,3 21,10" />
      {/* Door */}
      <rect x="10" y="14" width="4" height="6" />
      {/* Optional windows */}
      <line x1="8" y1="12" x2="10" y2="12" />
      <line x1="14" y1="12" x2="16" y2="12" />
    </svg>
  ),
  description: "Estimate your property taxes and plan your finances effectively."
},
    { 
      name: "Tax Return",
  path: "/TaxReturnCalculatorUSA",
  icon: (
    <svg
      width="39"
      height="39"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Document outline */}
      <rect x="3" y="2" width="18" height="20" rx="2" ry="2" />
      {/* Folded corner */}
      <polyline points="3,6 12,2 21,6" />
      {/* Text lines */}
      <line x1="6" y1="10" x2="18" y2="10" />
      <line x1="6" y1="14" x2="18" y2="14" />
      <line x1="6" y1="18" x2="18" y2="18" />
    </svg>
  ),
  description: "Prepare and review your tax returns accurately and efficiently."
},
    { 
      name: "Retirement Tax",
  path: "/RetirementTaxCalculatorUSA",
  icon:(
    <svg
      width="35"
      height="35"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Shield */}
      <path d="M12 2 L4 6 V12 C4 17 8 21 12 22 C16 21 20 17 20 12 V6 L12 2 Z" />
      {/* Checkmark */}
      <polyline points="9,12 11,14 15,10" />
    </svg>
  ),
  description: "Estimate taxes on your retirement income and plan your savings efficiently."
},
{ 
  name: "Pension Tax",
  path: "/PensionTaxCalculatorUSA",
  icon: (<svg
      width="39"
      height="39"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Wallet body */}
      <rect x="3" y="7" width="18" height="12" rx="2" ry="2" />
      {/* Wallet flap */}
      <line x1="3" y1="10" x2="21" y2="10" />
      {/* Coin or clasp */}
      <circle cx="18" cy="13" r="1.5" />
    </svg>
    ),
  description: "Calculate taxes on your pension income and plan your finances effectively."
},
{
  name: "Inheritance Tax",
  path: "/InheritanceTaxCalculatorUSA",
  icon: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Document */}
      <rect x="6" y="4" width="12" height="16" rx="2" ry="2" />
      {/* Legal text lines */}
      <line x1="8" y1="8" x2="16" y2="8" />
      <line x1="8" y1="12" x2="16" y2="12" />
      <line x1="8" y1="16" x2="14" y2="16" />
      {/* Checkmark or approval */}
      <polyline points="10,18 12,20 16,16" />
    </svg>
  ),
  description: "Calculate potential inheritance taxes and plan estate transfers effectively."
},
{
  name: "Capital Gains Tax",
  path: "/CapitalGainsCalculatorUSA",
  icon: (
    <svg
      width="39"
      height="39"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Coin stack */}
      <ellipse cx="12" cy="16" rx="6" ry="2" />
      <ellipse cx="12" cy="13" rx="6" ry="2" />
      <ellipse cx="12" cy="10" rx="6" ry="2" />
      {/* Upward arrow to represent gains */}
      <line x1="12" y1="7" x2="12" y2="3" />
      <polyline points="10,5 12,3 14,5" />
    </svg>
  ),
  description: "Estimate taxes on your investment profits and optimize your capital gains strategy."
},
{
  name: "Tax Refund",
  path: "/TaxRefundCalculatorUSA",
  icon: (
    <svg
  width="35"
  height="35"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <text
    x="50%"
    y="50%"
    textAnchor="middle"
    dominantBaseline="middle"
    fontSize="20"
    fontFamily="Arial, sans-serif"
    fill="currentColor"
  >
    $
  </text>
</svg>
  ),
  description: "Estimate how much tax refund you may receive based on your yearly income and deductions."
},

{
  name: "Estate Planning",
  path: "/EstatePlanningCalculatorUSA",
  icon: (
    <svg
      width="39"
      height="39"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* House icon representing estate */}
      <path d="M3 12 L12 3 L21 12" />  {/* Roof */}
      <rect x="6" y="12" width="12" height="9" /> {/* House body */}
      {/* Family figure */}
      <circle cx="9" cy="16" r="1" />
      <circle cx="15" cy="16" r="1" />
    </svg>
  ),
  description: "Plan your estate efficiently, including asset distribution, trusts, and inheritance taxes."
},

{
  name: "Probate Cost",
  path: "/ProbateCostCalculatorUSA",
  icon: (
    <svg
      width="39"
      height="39"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Document icon representing probate */}
      <path d="M6 2h8l4 4v16H6z" /> {/* Document */}
      <path d="M14 2v4h4" /> {/* Fold */}
      
      {/* Dollar sign */}
      <line x1="12" y1="9" x2="12" y2="17" />
      <path d="M10 11c0-1 1-2 2-2s2 1 2 2-1 2-2 2-2 1-2 2 1 2 2 2 2-1 2-2" />
    </svg>
  ),
  description: "Estimate probate costs, court fees, and legal expenses to understand how much an estate may lose during probate."
}


  ];

  const featuredToolsRef = useRef(null);
  const handleClick = () => {
  featuredToolsRef.current?.scrollIntoView({ behavior: 'smooth' });
};

  const handleToolsClick = () => {
    navigate('/PayrollCalculatorUSA');
  };

  return (
    <div className="cont-1">
      {/* Hero Section */}
      <div className="hero-section">
        <div className="hero-content">
          <div className="hero-badge">
            <i className="fa-solid fa-rocket"></i>
            All-in-One Financial Platform
          </div>
          <h1 className="hero-title">
            <span className="hero-gradient">Smart Financial Tools</span>
            <br />
            For Your Payroll Needs
          </h1>
          <p className="hero-subtitle">
            Professional-grade payroll, tax, and net pay calculations. 
            Trusted by employees and employers for accurate financial insights.
          </p>
          <div className="hero-actions">
            <button className="cta-button primary" onClick={handleClick}>
              <i className="fa-solid fa-wrench"></i>
              Explore Our Tools
            </button>
            <NavLink to="/AboutUs" className="cta-button secondary">
              <i className="fa-solid fa-circle-info"></i>
              Learn More
            </NavLink>
          </div>
        </div>
        <div className="hero-visual">
          <div className="floating-card card-1">
            <i className="fa-solid fa-calculator"></i>
            <span>Payroll</span>
          </div>
          <div className="floating-card card-2">
            <i className="fa-solid fa-chart-pie"></i>
            <span>Taxes</span>
          </div>
          <div className="floating-card card-3">
            <i className="fa-solid fa-wallet"></i>
            <span>Net Pay</span>
          </div>
          <div className="floating-card card-4">
            <i className="fa fa-landmark"></i>
            <span>Estate</span>
          </div>
          <div className="floating-card card-5">
            <i className="fas fa-piggy-bank"></i>
            <span>Savings</span>
          </div>
          <div className="floating-card card-6">
            <i className="fas fa-chart-line"></i>
            <span>Capital</span>
          </div>
          <div className="floating-card card-7">
            <i className="fas fa-home"></i>
            <span>Mortgage</span>
          </div>
        </div>
      </div>

      {/* Tools Grid Section */}
      <div className="home-container">
        <div className="section-header" ref={featuredToolsRef}>
          <h2 className="section-title1">
            <i className="fa-solid fa-star"></i>
            Featured Tools
          </h2>
          <p className="section-subtitle">
            Professional tools designed for accurate financial calculations
          </p>
        </div>

        <div className="grid-layout">
          {tools.map((tool, idx) => (
            <NavLink 
              to={tool.path} 
              key={idx} 
              className="category-card"
              onMouseEnter={() => setIsHovered(idx)}
              onMouseLeave={() => setIsHovered(null)}
            >
              <div className="card-icon">
                {tool.icon}
              </div>
              <div className="card-content">
                <h3 className="card-title">{tool.name}</h3>
                <p className="tool-desc">{tool.description}</p>
              </div>
              <div className={`card-hover ${isHovered === idx ? 'active' : ''}`}>
                <i className="fa-solid fa-arrow-right"></i>
              </div>
            </NavLink>
          ))}
        </div>

        {/* CTA Section */}
        <div className="cta-section">
          <div className="cta-content">
            <h3>Ready to Optimize Your Finances?</h3>
            <p>Access all our professional tools and features</p>
            <button className="cta-button primary large" onClick={handleToolsClick}>
              <i className="fa-solid fa-rocket"></i>
              Get Started Now
            </button>
          </div>
        </div>

        {/* Features Section */}
        <section className="about-section">
          <div className="features-grid">
  <div className="feature-card">
    <div className="feature-icon">
      <i className="fa-solid fa-lock"></i>
    </div>
    <h4>Free Forever</h4>
    <p>All calculators and estimators are completely free to use with no hidden costs.</p>
  </div>
  <div className="feature-card">
    <div className="feature-icon">
      <i className="fa-solid fa-users"></i>
    </div>
    <h4>User Friendly</h4>
    <p>Simple, intuitive interface perfect for both employees and employers.</p>
  </div>
  <div className="feature-card">
    <div className="feature-icon">
      <i className="fa-solid fa-globe"></i>
    </div>
    <h4>Global Coverage</h4>
    <p>Supports multiple countries and tax systems, making it versatile for international users.</p>
  </div>
</div>

        </section>
      </div>
    </div>
  );
};

export default Home;